import React, { useEffect, useContext, useState, useCallback } from 'react'
import style from '../../../styles/mystyle.module.css'
import { Navbar } from '../Layout/Navbar'
import axios from 'axios'
import TermsContext from "../../../context/Trems"
import * as config from '../../../next.config'
import { useTranslation } from "next-i18next";
import CurrencyContext from '../../../context/currencyProvider'
import { useRouter } from 'next/router'
import { Tabs, Tab } from "react-tabs-scrollable";
import LoadingJSON from '../Loaders/Loading';
import { getImage } from '../../helpers/images'
import "react-tabs-scrollable/dist/rts.css";
import SeeMore from '../SeeMore'
import { getCookieValue } from '../../helpers/helpers'
import Typography from '@mui/material/Typography'
import { constants } from '../../../constants'
import Link from 'next/link'
import getOffers from '../../helpers/offers'
import { useCart } from "../../../context/cart/use-cart";
import MinusIcon from "@mui/icons-material/Remove"
import AddIcon from "@mui/icons-material/Add"
import QuantityDialog from "../Dialogs/QuantityDialog"
import ProductUnitsPriceFeatures from "../Dialogs/ProductUnitsPriceFeatures"
import { CustomeCard, CustomeCardMedia, CustomeCardActions, CustomeCardContent, CustomeIconbtn }
  from "./Offer.style"
import SearchOffer from "./SearchOffer"
import NoData from "../NoData"
function Main() {
  let limit = 5000
  const router = useRouter()
  const { t } = useTranslation("common");
  const vocabTerms = useContext(TermsContext)
  const currency = useContext(CurrencyContext)
  const [lstTags, setLstTags] = useState([{ name: t("all"), code: t("all") }])
  const [lstCountriesData, setLstCountriesData] = useState([])
  let time = new Date().valueOf()
  useEffect(() => {
    let countriesData = vocabTerms.countries.filter(x => x.language && x.language.code == router.locale)
    // let data = {
    //   display: true,
    //   active: true,
    //   statusIds: vocabTerms.statusIds,
    //   "toDate": time,
    //   langId: router.locale,
    //   pageId: 1,
    //   limit: limit,
    //   countryId: countriesData != null ? countriesData.filter(x => x.code == "yemen")[0].id : lstCountriesData.filter(x => x.code == "yemen")[0].id,
    //   productCategoriesIDs: JSON.stringify(["medicine", "food"])
    // };
    // axios
    //   .get(`${config["basePath"]}/api/products/offers/getTagsName`, {
    //     params: { ...data, limit: 5000 }
    //   }).then(async off => {

    //     let listOfTags = []
    //     let listOfTagName = []
    //     off.data.content.filter(ele => ele.productTagName != null).map(ele => {
    //       let indexOfTagName = listOfTagName.indexOf(ele.productTagName)
    //       if (indexOfTagName == -1) {
    //         listOfTagName.push(ele.productTagName)
    //         listOfTags.push(ele)
    //       }
    //     })
    //     setLstTags([...lstTags].concat(...listOfTags))
    //   }).catch(err => console.log("err=======>", err))
  }, [])
  useEffect(() => {
    let countriesData = vocabTerms.countries.filter(x => x.language && x.language.code == router.locale)
    setLstCountriesData(countriesData.filter(x => status.includes(x.statusId)))

  }, []);

  // Tab code ------------------------------------------->
  const [products, setProducts] = useState([]);
  const [loadingData, setLoadingData] = React.useState(true)
  const [pageId, setPageId] = React.useState(1);
  const [showSeeMore, setShowSeeMore] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState('')
  const [imagesLst, setImagesLst] = useState([])

  const { locale } = useRouter();
  const { addItem, removeItem, isInCart, getItem } = useCart();
  const [featuerDailogData, setfeatuerDailogData] = useState({ data: null, open: false })
  const [DataQuantityDialog, setDataQuantityDialog] = useState({ open: false, entityDetailsId: null, productUnitPriceId: null, productId: null, quantity: null })
  const [searchName, setSearchName] = useState(null)
  const [noFound, setNoFound] = useState(false)
  const [entitiesOffers,setEntitiesOffers]=React.useState([])
  function getAllTages(pageNumber, countriesData, category, OfferName) {
    let data = {
      langId: router.locale,
      pageId: pageNumber,
      limit: 100,

      statusId:JSON.stringify(vocabTerms.statusIds) ,
      "sortBy": JSON.stringify(["weight asc", "updated_on desc"]),
    };
    if (countriesData.length > 0) {
      data.countryId = countriesData[0].id
    }
    if (category) {
      data.productOfferTags = JSON.stringify(category)
    }
    if (OfferName && OfferName != '' && OfferName != null) {
      data.productName = OfferName
    }
    axios.post(`${config['basePath']}/api/products/reports/reportProductOrderOfferTopPrice/get`,
    {
        data: data
    }).then(async (entities) => {

setLoadingData(false)
// console.log("temp=========>",entities.data.data)
let temp=entities.data.data.filter(ele=>ele.active&&ele.percentage>0).map(ele => {
    ele.entityImages.map(async r => {
        if(r.files){
            r.image =  await getImage(r.files.fileId, r.files.filePath)
            setImagesLst(prev => [...prev, r])
        }
        return r
    
      })   
     return ele
    })
 
    let listOfTags = []
    let listOfTagName = []
    temp.map(ele=>{
    if(ele.entityType.length>0&&ele.entityType[0].code=="merchant"){

   
  let tempCategory=ele.entityCategories.length>0&&ele.entityCategories[0].entityCategories.filter(x=>x.language&&x.language.code==router.locale&&vocabTerms.statusIds.includes(x.statusId))
  if(tempCategory&&tempCategory.length>0){


    let indexOfTagName = listOfTagName.indexOf(tempCategory[0].name)
    if (indexOfTagName == -1) {
      listOfTagName.push(tempCategory[0].name)
      listOfTags.push(tempCategory[0])
    }
  }
  }
  else{
    let tempCategory=ele.entityType.filter(x=>x.language&&x.language.code==router.locale&&vocabTerms.statusIds.includes(x.statusId))
    if(tempCategory.length>0){

   
    let indexOfTagName = listOfTagName.indexOf(tempCategory[0].name)
    if (indexOfTagName == -1) {
      listOfTagName.push(tempCategory[0].name)
      listOfTags.push(tempCategory[0])
    }
  }
}
  })
//   temp=temp.filter(x=>x.active&&x.percentage>0).map(ele=>{
//     ele.offers.map(x=>{
//         if(x.percentage==0){
//             x.percentage=1
//         }
//     })
//     return ele
// })

temp=temp.sort((c,d)=>{
    if(c.offers.sort((a,b)=>a.percentage>b.percentage).length>0&& d.offers.sort((a,b)=>a.percentage>b.percentage).length>0){
       if(c.offers.sort((a,b)=>a.percentage>b.percentage)[0].percentage<=d.offers.filter(ele=>ele.percentage).sort((a,b)=>a.percentage>b.percentage)[0].percentage){
                   return 1
               }
               else{
                   return -1
               }
   }
   else{
       return -1
   }
})
    setLstTags([...lstTags].concat(...listOfTags))
    setEntitiesOffers(temp)
    setProducts(temp)
    }).catch(err=>console.log(err))
 
  }
  useEffect(() => {
    // setLstTags(props.tags)
    let countriesData = vocabTerms.countries.filter(x => x.code == getCookieValue("userCountry") && x.language && x.language.code == router.locale)

    if (lstTags.length > 0) {
      setSelectedCategory(lstTags[0].productTagCode)
      getAllTages(pageId, countriesData, null)
    }
  }, []);
  const handleClose = () => {
    setfeatuerDailogData({ open: false });
  };
  const [tabsValue, setTabsValue] = useState(0)
  const handleTabsChange = (newValue) => {
   
    let tempLst=[]
 
    if (newValue != 0) {
      if (newValue != undefined && newValue != null) {
        products.map(ele=>{
          if(ele.entityType[0].code==lstTags[newValue].code){
            tempLst.push(ele)
          }
          else{
         
            if(ele.entityCategories.map(x=>x.entityCategories.length>0&&x.entityCategories.filter(d=>d.language.code==router.locale).length>0&&x.entityCategories.filter(d=>d.language.code==router.locale)[0]).filter(x=>x.code==lstTags[newValue].code).length>0){
              tempLst.push(ele) 
          }
          }
        })
        setEntitiesOffers([...tempLst])
    }}
    else {
      setEntitiesOffers([...products])
    }
    setTabsValue(newValue)
  }
  let temListOfProductsIds = []

  const getMore = () => {
    setLoadingData(true)
    setPageId(prev => prev + 1)
    let pageNumber = pageId + 1
    if (selectedCategory != t("all")) {
      getAllTages(pageNumber, vocabTerms.countries.filter(x => x.code == getCookieValue("userCountry") && x.language && x.language.code == router.locale), [selectedCategory])

    }
    else {
      getAllTages(pageNumber, vocabTerms.countries.filter(x => x.code == getCookieValue("userCountry") && x.language && x.language.code == router.locale), null)

    }
  }

  const searchOfferName = useCallback(
    async callback => {

      setSearchName(callback);
      setLoadingData(true)
      setProducts([])
      await getAllTages(1, lstCountriesData, null, callback)


    },
    [searchName]
  );
  return (
    <div className={style.ContainerMargin} style={{ backgroundColor: "white" }}>
      <Navbar showDownloadAppSection={false} exchangeAllCurrenciesCallBack={(res) => (res)} currenciesCallBack={(res) => (res)}>
       
        <div
          className={
            style.SectionContainer + " " + " " + style.paddingproduct
          }
        >

          {featuerDailogData.open ?
            <ProductUnitsPriceFeatures data={featuerDailogData.data} onClose={handleClose} open={featuerDailogData.open} /> : ""}
          <div className={style.Container + " " + style.paddingSearch}>

          </div>

          <div className={style.Container}>
            <div className={style.HeaderandBasketIconpagebasket}>
              <div>
                <img
                  className={style.icontitle}
                  src={`${config.basePath}/assest/offers.svg`}
                />
              </div>
              <div className={style.textaboutdoctor1 + " " + style.Blod}>
                {t("entitiesOffers")}
              </div>
            </div>
            <div className={style.paddingTaboffers}>
         
              {lstTags && lstTags.length > 0 && lstTags.length > 1
                ?
                <Tabs
                  activeTab={tabsValue}
                  onTabClick={(e, newValue) => handleTabsChange(newValue, null)}
                  hideNavBtnsOnMobile={true}
                  isRTL={router.locale == "ar" ? true : false}
                  rightNavBtnClassName="rtl-btn"
                  leftNavBtnClassName="ltr-btn"
                  tabsContainerClassName="menu-container"
                >
                  {
                    lstTags && lstTags.length > 0
                      ?
                      lstTags.map((ele, index) => {

                        return (
                          <Tab className="test" index={index} key={index} style={{ display: "flex" }} >
                            {ele.name}
                          </Tab>

                        )
                      })

                      : ""
                  }


                </Tabs>
                : ""}
              {/* <SearchOffer searchOfferName={searchOfferName} /> */}
            </div>

          </div>

          {noFound ?
            <NoData /> : ""}

          <div className={style.allcard}>


            <div className={style.ShowOffer}>
           
              {entitiesOffers && entitiesOffers.length > 0
                ? entitiesOffers.map((productItem, index) => {
                  // let indexOfProductId = temListOfProductsIds.indexOf(productItem.productUnitPriceId)
                  // if (indexOfProductId == -1) {
                  //   temListOfProductsIds.push(productItem.productUnitPriceId
                  //   )
                    return (
                      <div key={index}>


                        {
                          productItem ?
                            <div>

                              <div className={style.allcard + " "}>

                                <CustomeCard>
                                {(()=>{
  let pathname = ''
  if (productItem.entityType[0].code == "merchant") {
      if (productItem.entityCategories.length > 0 && productItem.entityCategories[0].entityCategories.length > 0) {
          pathname = (`${constants.HakeemMedical}/${productItem.entityCategories[0].entityCategories[0].code}/${productItem.slug && productItem.slug.length > 0 && productItem.slug.filter(i => i.active == true).length > 0 ? productItem.slug.filter(i => i.active == true)[0].url : productItem.id}/meals`).replace('/[^a-zA-Z0-9-_]/g', '')
      }
      else {
          pathname = (`${constants.HakeemMedical}/${productItem.entityType[0].code}/${productItem.slug.length > 0 && productItem.slug.filter(i => i.active == true).length > 0 ? productItem.slug.filter(i => i.active == true)[0].url : productItem.id}/meals`).replace('/[^a-zA-Z0-9-_]/g', '')
      }
  }
  else if (JSON.parse(config.env.hakeemShoppingOnEntityTypesCodes).filter(x => x == productItem.entityType[0].code).length > 0) {
      pathname = (`${constants.HakeemMedical}/${productItem.entityType[0].code}/${productItem.slug.length > 0 && productItem.slug.filter(i => i.active == true).length > 0 ? productItem.slug.filter(i => i.active == true)[0].url : productItem.id}/meals`).replace('/[^a-zA-Z0-9-_]/g', '')
  }
  else {
      pathname = (`${constants.HakeemMedical}/${productItem.entityType[0].code}/${productItem.slug.length > 0 && productItem.slug.filter(i => i.active == true).length > 0 ? productItem.slug.filter(i => i.active == true)[0].url : productItem.id}`).replace('/[^a-zA-Z0-9-_]/g', '')
  }

  return <Link className={style.AtagIcon + " " + style.hoverLink + " " + style.ColorBlack}
  href={pathname} passHref >
  <CustomeCardMedia
    component="img"
    sx={{ 1000: { height: "380", width: "380" }, 400: { height: "350", width: "350" } }}
    image={
      productItem.entityImages.length > 0 && imagesLst.filter(ele => ele.entityDetailsId == productItem.id&&ele.image!=null&&ele.image!='').length > 0  ?
      imagesLst.filter(ele => ele.entityDetailsId == productItem.id&&ele.image!=null&&ele.image!='')[0].image
    
        :
        `${config.basePath}/assest/logo.svg`
    }
    alt="image"
  />
</Link>
                    })()}
                                  
                                  <CustomeCardContent>
                                  {(()=>{
  let pathname = ''
  if (productItem.entityType[0].code == "merchant") {
      if (productItem.entityCategories.length > 0 && productItem.entityCategories[0].entityCategories.length > 0) {
          pathname = (`${constants.HakeemMedical}/${productItem.entityCategories[0].entityCategories[0].code}/${productItem.slug && productItem.slug.length > 0 && productItem.slug.filter(i => i.active == true).length > 0 ? productItem.slug.filter(i => i.active == true)[0].url : productItem.id}/meals`).replace('/[^a-zA-Z0-9-_]/g', '')
      }
      else {
          pathname = (`${constants.HakeemMedical}/${productItem.entityType[0].code}/${productItem.slug.length > 0 && productItem.slug.filter(i => i.active == true).length > 0 ? productItem.slug.filter(i => i.active == true)[0].url : productItem.id}/meals`).replace('/[^a-zA-Z0-9-_]/g', '')
      }
  }
  else if (JSON.parse(config.env.hakeemShoppingOnEntityTypesCodes).filter(x => x == productItem.entityType[0].code).length > 0) {
      pathname = (`${constants.HakeemMedical}/${productItem.entityType[0].code}/${productItem.slug.length > 0 && item.slug.filter(i => i.active == true).length > 0 ? productItem.slug.filter(i => i.active == true)[0].url : productItem.id}/meals`).replace('/[^a-zA-Z0-9-_]/g', '')
  }
  else {
      pathname = (`${constants.HakeemMedical}/${productItem.entityType[0].code}/${productItem.slug.length > 0 && productItem.slug.filter(i => i.active == true).length > 0 ? productItem.slug.filter(i => i.active == true)[0].url : productItem.id}`).replace('/[^a-zA-Z0-9-_]/g', '')
  }

                        return <Link className={style.AtagIcon + " " + style.hoverLink + " " + style.ColorBlack}
                        href={pathname} passHref >
                        <Typography fontWeight="600" gutterBottom variant="h5" component="div" marginBottom={0}>
  
                        {  productItem.transEntityDetails[0].officialName&& productItem.transEntityDetails[0].officialName.length  > 20 ?
          productItem.transEntityDetails[0].officialName.substr(0, 20) + "..." : 
          productItem.transEntityDetails[0].officialName } 
           
             {" "}
                        </Typography>
                      </Link>
                    })()}
                                    
                                    <Typography gutterBottom variant="h5" component="div">
                                    {productItem &&  productItem.addressDetails ?
                        productItem.addressDetails[0].physicalAddress.length > 28 ?
                        productItem.addressDetails[0].physicalAddress.substr(0, 28) + "..." :
                        productItem.addressDetails[0].physicalAddress : ""}                                  </Typography>
                                  </CustomeCardContent>
                                  <CustomeCardActions>
                                  {productItem.offers.length>0&&productItem.offers.filter(ele=>ele.percentage>1).sort((a,b)=>a.percentage>b.percentage).length>0?<div className='absolute justify-center flex left-0 md:left-0 p-1 bg-[#F52A59] text-white rounded-b-md top-0 w-full'>{t("discountUpTo")}{productItem.offers.filter(ele=>ele.percentage).sort((a,b)=>a.percentage>b.percentage)[0].percentage} %</div>:""}

                                  {/* {productItem.percentage>0?<div className='absolute justify-center flex left-0 md:left-0 p-1 bg-[#F52A59] text-white rounded-b-md top-0 w-full'>{t("discountUpTo")}{productItem.percentage} %</div>:""} */}

                                    {/* {(() => {
                                      if (getOffers(
                                        productItem.fixedPrecentage,
                                        productItem.price,
                                        productItem.fixedAmount
                                      ) > 0) {



                                        return <>

                                          <div className={style.DisCountSquare}>

                                            <div className={style.SquareOffer}>{t("offer")}</div>
                                          </div>

                                        </>

                                      }
                                    })()} */}



                                    <div className={style.TwotextpriceProduct + " " + style.paddingTextProduct}>


                                     

                                    </div>

                                    <br />


                                    <div className={style.AddCart}  >
                                     
                                    </div>
                                  </CustomeCardActions>
                                </CustomeCard>
                              </div></div>
                            : ""
                        }
                      </div>
                    );
                  // }
                })
                :
                " "
              }
            </div>
          </div>
          <div className={style.paddingBottom}></div>
          {loadingData == false && showSeeMore ? (
            <div className={style.textaboutdoctor1 + " " + style.Blod} >
              <SeeMore getMore={getMore} loading={loadingData} />
            </div>
          ) : (
            ""
          )}

          {loadingData ? <div style={{ textAlign: "center", display: "flex", justifyContent: "center" }}><LoadingJSON start={loadingData}></LoadingJSON></div> : ""}
        </div>
      </Navbar>
    </div>
  )
}

export default Main
